import React, { useState } from 'react';

// Components
import { Button } from '@capintel/component-lib/button';
import { FormattedMessageV2 } from '@/views/components/i18n';
import { Input } from '@/views/components/inputs';

// Utils
import { formatMessage } from '@/utils/i18n';

type Props = {
  existingName?: string;
  isRenaming?: boolean;
  closeModal: () => void;
  onSubmit: (name: string) => Promise<void>;
};

export const NameRiskProfile: React.FC<Props> = ({ existingName, isRenaming, closeModal, onSubmit }) => {
  const [name, setName] = useState<string>(isRenaming && existingName ? existingName.trim() : '');

  const isSubmitDisabled = name.length <= 0;

  return (
    <>
      <div className="name-risk-profile-content">
        <FormattedMessageV2 className="name-risk-profile-description" toLocalize="RiskProfileModal.NameRiskProfile.Description" />
        <Input
          className="input-v2 name-risk-profile-input"
          maxLength={50}
          onValueChange={setName}
          placeholder={formatMessage('RiskProfileModal.NameRiskProfile.Placeholder')}
          value={name}
          autoFocus
        />
      </div>
      <div className="name-risk-profile-footer">
        <Button variant="secondary" onClick={closeModal}>
          {formatMessage('RiskProfileModal.NameRiskProfile.Cancel')}
        </Button>
        <Button variant="primary" onClick={() => onSubmit(name)} disabled={isSubmitDisabled}>
          {formatMessage(`RiskProfileModal.NameRiskProfile.${!isRenaming ? 'Continue' : 'Save'}`)}
        </Button>
      </div>
    </>
  );
};
